import { useServices } from "@/hooks/useServices"
import { useTranslation } from "@/hooks/useTranslation"
import { Fix, Remediation } from "@/icons"
import { InsightsFilter } from "./InsightsFilter"

import type { BaseInsightsFilterProps } from "."

export const FixInsightsFilter = (props: BaseInsightsFilterProps) => {
  const { t } = useTranslation()
  const { auth } = useServices()
  // The same keys the tags use, so the filter and the row always read alike.
  const filterMeta = {
    fixVersion: { title: t("insights.hasFixVersion"), Icon: Fix },
    kodemRemediation: {
      title: t(
        auth.isDemo()
          ? "insights.availableRemediations"
          : "insights.hasKodemRemediation"
      ),
      Icon: Remediation
    }
  }

  return <InsightsFilter title="Fix" filtersMeta={filterMeta} {...props} />
}
